import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tasksKeyMaker } from "../../Tasks/hooks/useGetTasks";
import executePlanV2 from "../requests/executePlanV2";
import { getPlanDetailsV2KeyMaker } from "./usePlanDetailsV2";
import { getPlansV2KeyMaker } from "./usePlansV2";
export default function useExecutePlanV2(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (planId) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return await executePlanV2(planId, config);
        },
        onSuccess: (_, planId) => {
            queryClient.invalidateQueries(getPlansV2KeyMaker());
            queryClient.invalidateQueries(getPlanDetailsV2KeyMaker(planId));
            //Fidelity & Schwab client plans that contain Standing Instructions generate a new task when executed
            queryClient.invalidateQueries({ queryKey: tasksKeyMaker(null) });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useExecutePlanV2.js.map